export const Home = "/";
export const SSOHome = "/sso/auth";
export const SSOCallbackRoute = "/sso/callback";
export const AboutRoute = "/about";
export const OrderRoute = "/order";
export const OrderFinishRoute = OrderRoute+ "/finish";
export const SiteSearchRoute = "/site-search";
export const SiteSearchOptionsRoute = "/clinic-search-options";
export const OrdersRoute = "/orders";
export const GovDonorRoute = "/gov-donor";
export const RandomsRoute = "/random";
export const RandomsGovRoute = "/random-gov";
export const ConsortiumsRoute = "/consortiums";
export const GovOrderRoute = "/gov-order";
export const RandomsPersonnelRoute = RandomsRoute+ "/personnel";
export const ConsortiumPersonnelRoute = "/consortium-personnel";
export const SelectionInboxRoute = "/selection-inbox";
export const OurTeamStatusRoute = "/our-team-status";
export const MyInformationRoute = "/account/my-information";
export const BaseAdministrationRoute = "/administration";
export const MyOrganizationRoute = BaseAdministrationRoute+"/my-organization/";
export const MyOrganizationNameRoute = BaseAdministrationRoute+"/my-organization/:name";
export const AddNewPortalRoute = BaseAdministrationRoute+"/add-new-portal/";
export const PortalDetailsRoute = (name?: string) => BaseAdministrationRoute+"/my-organization/"+name;
export const PortalAdministrationRoute = BaseAdministrationRoute+"/portal-administration";
export const CompanyInformationRoute = BaseAdministrationRoute+"/company-information";
export const CompanyInformationNameRoute = BaseAdministrationRoute+"/company-information/:companyName";
export const CompanyDetailsRoute = (name?: string) => BaseAdministrationRoute+"/company-information/"+name;
export const AddNewCompanyRoute = BaseAdministrationRoute+"/add-new-company/";
export const AddNewCompanyNameRoute = BaseAdministrationRoute+"/add-new-company/:name";
export const AddCompanyForPortalRoute = (name?: string) => BaseAdministrationRoute+"/add-new-company/"+name;
export const LocationInformationRoute = BaseAdministrationRoute+"/location-information"
export const ActivateUserRoute = BaseAdministrationRoute+"/user-activation";
export const ActivateCompanyRoute = BaseAdministrationRoute+"/company-activation";
export const ActivatePortalRoute = BaseAdministrationRoute+"/portal-activation";
export const GlobalParameterRoute = BaseAdministrationRoute+"/global-parameter";
export const OrderableServicesRoute = BaseAdministrationRoute+"/orderable-services";
export const UserCodesRoute = BaseAdministrationRoute+"/user-codes";
export const UserLabelsRoute = BaseAdministrationRoute+"/user-labels";
export const RegulatoryModeRoute = "/regulatory-mode";
export const OrphanedResultsRoute = "/orphaned-results";
export const PermissionsRoute = "/roles-permissions";
export const InviteStatusRoute = "/invitation-status";
export const BaseInviteRoute = "/invitation";
export const InviteSiteAdmininstratorRoute = BaseInviteRoute+"/site-administrator";
export const LegacyWorkforceClientRoute = "/client";
const LegacyWorkforceUserRoute = "/user";
export const LegacyWorkforceInvitationRoute = LegacyWorkforceClientRoute + "/initial-setup";
export const LegacyWorkforceUserInvitationRoute = LegacyWorkforceUserRoute + "/initial-setup";
export const LegacyWorkforceCompanyInvitationRoute = LegacyWorkforceClientRoute + "/initial-setup";
export const LegacyWorkforcePortalInvitationRoute = "/initial-setup";
export const WorkforceOnePswUpdate = "/update-password";
export const WorkforceOnePswConfigureRoute = "/configure-password";
export const SSOOrderRoute = "/sso/order";
export const SSOOrderFinishRoute = SSOOrderRoute + "/finish";
export const SSOSiteSearchRoute = "/sso/site-search";
export const ReportPositiveRoute = "/report/positive";
export const SSOGetAuthFormRoute = "/sso/getauthform";
export const ReportTestingSummaryRoute = "/report/testing-summary";
export const ReportSpecimenPositivityRoute = "/report/specimen-positivity";
export const ReportDrugDetailRoute = "/report/drug-detail";
export const ReportDailySummaryRoute = "/report/daily-summary";
export const ReportIvrCallInComplianceRoute = "/report/ivr-call-in-compliance";
export const ReportNoShowRoute = "/report/no-show";
export const ReportCertificationRenewalRoute = "/report/cert-renewal";
export const ReportCertificationStatusRoute = "/report/cert-status";
export const ReportManagementSummaryRoute = "/report/management-summary";
export const ReportMISRoute = "/report/mis";
export const ReportSelectedNotTestedRoute = "/report/selected-not-tested";
export const ReportSummaryRoute = "/report/summary";
export const ReportUnmergedRandomResultsRoute = "/report/unmerged_random_results";
export const ConfigureOrderDefaultsRoute = BaseAdministrationRoute+"/order-defaults";
export const SendingFacilityRoute = "/sending-facilities";
export const LabResultsReportingRoute = BaseAdministrationRoute+"/lab-results-reporting";
export const ReportUnmergedRandomResults = "/report/unmerged-random-results";
export const ReportRegulatoryQualityControlRoute = "/report/regulatory-quality-control";
export const ReportMissingRegModeOrEmpCategoryRoute = "/report/missing-reg-mode-or-emp-category";

export const LegacyWorkforceLogInRoute = "/workforce-login";
export type ParameterFreeRouteType = '/'| '/order'| '/order/finish' | '/site-search' | '/orders' | '/random' |  '/random/personnel' | '/consortiums' | '/consortium-personnel' | '/selection-inbox' | '/clinic-search-options';
export default ParameterFreeRouteType;
